import ApiService from '../api.services';

const DepartmentService = {
    chats: async function () {
        try {
            const response = await ApiService.get(`/api/departments/chat/rooms`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    list: async function (records, page, search) {
        try {
            const response = await ApiService.get(`/api/departments?records=${records}&page=${page}&search=${search}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    listByCustomer: async function (customer) {
        try {
            const response = await ApiService.get(`/api/departments/customer/${customer}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/departments/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {
        const data = {
            department: form
        }
        try {
            const response = await ApiService.post('/api/departments', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            department: form
        }
        try {
            const response = await ApiService.put(`/api/departments/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/departments/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default DepartmentService;

export { DepartmentService };

